export const LiveIcon = () => {
  return (
    <div className="absolute -right-1 -top-1 size-3 animate-pulse rounded-full border-2 border-fg-primary bg-fg-lime-primary shadow-xs" />
  )
}
